import type { QualifyAdvisorFirst } from '../lib/api/types';

// Matched only renders for advisor-first routes (Lead Owner, Existing
// Client). Slot-first routes skip this screen entirely — see App.tsx.
interface Props {
  match: QualifyAdvisorFirst;
  onContinue: () => void;
}

export function Matched({ match, onContinue }: Props) {
  const { advisor, meetingDurationMinutes } = match;
  return (
    <div className="matched-state">
      <div className="matched-badge">
        <span className="matched-check">✓</span>
        <span>You're matched</span>
      </div>

      <h2 className="matched-headline">
        {advisor.firstName} {advisor.lastName}
      </h2>

      {advisor.bioShort && <p className="matched-bio">{advisor.bioShort}</p>}

      <div className="matched-meta">
        <div className="matched-meta-item">
          <span className="matched-meta-label">Meeting type</span>
          <span className="matched-meta-value">
            1st Appointment · Annuity Discovery
          </span>
        </div>
        <div className="matched-meta-item">
          <span className="matched-meta-label">Duration</span>
          <span className="matched-meta-value">{meetingDurationMinutes} minutes</span>
        </div>
        <div className="matched-meta-item">
          <span className="matched-meta-label">Format</span>
          <span className="matched-meta-value">Zoom video call</span>
        </div>
      </div>

      <button type="button" className="submit-btn" onClick={onContinue}>
        Pick a time with {advisor.firstName}
      </button>
    </div>
  );
}
